export const LiveTagLabelScadaIcon = () => (
  <svg width="54" height="17" viewBox="0 0 54 17" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="0.5" y="0.5" width="53" height="16" rx="1.5" stroke="#8C969B" />
    <rect x="5" y="6" width="22" height="5" fill="#CFD3D5" />
    <path
      d="M46.5039 4.75C44.4339 4.75 42.7539 6.43 42.7539 8.5C42.7539 10.57 44.4339 12.25 46.5039 12.25C48.5739 12.25 50.2539 10.57 50.2539 8.5C50.2539 6.43 48.5739 4.75 46.5039 4.75ZM45.4877 10.1088L44.1414 8.7625C43.9952 8.61625 43.9952 8.38 44.1414 8.23375C44.2877 8.0875 44.5239 8.0875 44.6702 8.23375L45.7539 9.31375L48.3339 6.73375C48.4802 6.5875 48.7164 6.5875 48.8627 6.73375C49.0089 6.88 49.0089 7.11625 48.8627 7.2625L46.0164 10.1088C45.8739 10.255 45.6339 10.255 45.4877 10.1088Z"
      fill="#CFD3D5"
    />
  </svg>
);
